import { GET_FORM_TEMPLATE_SUCCESS } from './';

export default templates => ({
  type: GET_FORM_TEMPLATE_SUCCESS,
  payload: templates,
});
